/** hiérarchie des réseaux */
export const OsmLevel = {
    URBAIN: 8,
    DEPT: 6,
    REGION: 4,
    COUNTRY: 2
}

/** nombres d'éléments par page */
export const PaginationNetwork = {
    ELMT_PER_PAGE: 25
}